import {
  Box,
  Button,
  Heading,
  HStack,
  Spinner,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from 'shared/hooks/usePermissions';
import BatchesTable from './components/BatchesTable';
import { useNfseContext } from './NfseContext';

const NfseLotes = () => {
  const navigate = useNavigate();
  const { batches, loading, error, loadBatches } = useNfseContext();
  const { e } = usePermissions();
  const canCreate = e('nfse-create');

  const bgColor = useColorModeValue('white', 'gray.800');

  useEffect(() => {
    loadBatches();
  }, [loadBatches]);

  const handleNewBatch = () => {
    navigate('/financeiro/novo-lote');
  };

  return (
    <Stack gap="1.5rem">
      <HStack justify="space-between" align="center">
        <Heading size="lg" fontWeight="500" color="gray.600">
          Lotes
        </Heading>
        {canCreate && (
          <Button colorScheme="yooga" onClick={handleNewBatch}>
            Novo lote
          </Button>
        )}
      </HStack>

      <Box bg={bgColor} borderRadius="lg" shadow="sm" p="1.5rem">
        {loading && (
          <HStack justify="center" py="4rem">
            <Spinner size="lg" color="yooga.500" />
            <Text>Carregando lotes...</Text>
          </HStack>
        )}

        {error && !loading && (
          <Stack align="center" py="4rem" gap="1rem">
            <Text color="red.500">{error}</Text>
            <Button onClick={loadBatches} colorScheme="yooga" variant="outline">
              Tentar novamente
            </Button>
          </Stack>
        )}

        {!loading && !error && batches.length === 0 && (
          <Stack align="center" py="4rem" gap="1rem">
            <Text color="gray.500">Nenhum lote encontrado</Text>
            {canCreate && (
              <Button onClick={handleNewBatch} colorScheme="yooga">
                Criar primeiro lote
              </Button>
            )}
          </Stack>
        )}

        {!loading && !error && batches.length > 0 && (
          <BatchesTable batches={batches} />
        )}
      </Box>
    </Stack>
  );
};

export default NfseLotes;
